import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { FilterProperty } from './../../../search/filter-property';

@Component({
  selector: 'app-field-radio',
  templateUrl: './field-radio.component.html',
  styleUrls: ['./field-radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FieldRadioComponent {
  @Input() suggestions: FilterProperty[];
  @Output() selectedInput = new EventEmitter<string>();
  @Input() option: any;

  constructor() {}

  public setOption() {
    this.selectedInput.emit(this.option);
  }
}
